module.exports = __webpack_public_path__ + "static/media/okrFlag.20bc8ada.svg";